export const sendRegistrationEvent = (component_name) => {
  window?.dataLayer?.push({
    event: 'navigate_to_register',
    component_name,
    original_location: location.pathname
  })
}